import { getCurrentBasic } from './core/ProgramService'

/**
 *
 * @description 汽车维权-浏览
 */
export async function reportCsrView() {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'WORK_ORDER',
            businessVer: 1,
            pageName: '汽车维权',
            pageUrl: window.location.href,
            ref1: 'CAR_SAFEGUARD',
            view: 1,
        }),
    )
}

/**
 *
 * @description 汽车维权-浏览案件
 */
export async function reportCsrViewCase(params: {
    caseId?: string | number
    pageName?: string | number
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'WORK_ORDER',
            businessVer: 1,
            pageName: '汽车维权案件',
            pageUrl: window.location.href,
            ref1: 'CAR_SAFEGUARD',
            ref2: params.caseId,
            view: 1,
        }),
    )
}

/**
 *
 * @description 汽车维权-发帖
 */
export async function reportCsrNote(params: {
    caseId?: string | number
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'WORK_ORDER',
            businessVer: 1,
            pageName: '汽车维权案件',
            pageUrl: window.location.href,
            ref1: 'CAR_SAFEGUARD',
            ref2: params.caseId,
            note: 1,
        }),
    )
}
